"use client";

import React, { useState } from "react";
import { Facebook, Instagram, Mail, MapPin, Phone, X, MessageSquare, X as CloseIcon } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-32 bg-muted animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    const fallbackLinks = [{
      label: "Weddings and Events",
      href: "/WeddingsEvents"
    }, {
      label: "Shop All Flowers",
      href: "/Shop"
    }, {
      label: "Floral Care Guide",
      href: "/FloralCare"
    }, {
      label: "Delivery Information",
      href: "/ContactDelivery"
    }];
    return <ul className="space-y-3">
        {fallbackLinks.map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="text-foreground/70 hover:text-primary transition-colors duration-200 font-default">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/70 hover:text-primary transition-colors duration-200 font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [isWeChatModalOpen, setIsWeChatModalOpen] = useState(false);
  const socialLinks = [{
    icon: Facebook,
    href: "https://www.facebook.com/share/1DJ71mmmtQ/?mibextid=wwXIfr",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://www.instagram.com/eternal.blooms.nz2025?igsh=MW1nZ2xzMGN2Yjdydw%3D%3D&utm_source=qr",
    label: "Instagram"
  }, {
    icon: X,
    href: "https://x.com",
    label: "X"
  }, {
    icon: MessageSquare,
    href: "#",
    label: "WeChat",
    hrefClassName: "bg-secondary hover:bg-primary hover:text-primary-foreground text-foreground/60 p-2.5 rounded-full transition-all duration-300 border border-border/50 !bg-[url(https://eternalblooms.store/wp-content/uploads/2026/05/wechat-logo-wechat-icon-transparent-free-png.webp)] bg-secondary hover:bg-primary hover:text-primary-foreground text-foreground/60 p-2.5 rounded-full transition-all duration-300 border border-border/50 !bg-[url(https://eternalblooms.store/wp-content/uploads/2026/05/wechat-logo-wechat-icon-transparent-free-png.webp)] bg-secondary hover:bg-primary hover:text-primary-foreground text-foreground/60 p-2.5 rounded-full transition-all duration-300 border border-border/50 !bg-[url(https://eternalblooms.store/wp-content/uploads/2026/05/wechat-logo-vector-wechat-social-media-app-icon_999008-2090.avif)] bg-secondary hover:bg-primary hover:text-primary-foreground text-foreground/60 p-2.5 rounded-full transition-all duration-300 border border-border/50 !bg-[url(https://eternalblooms.store/wp-content/uploads/2026/05/wechat-logo-wechat-icon-transparent-free-png-1.webp)]"
  }];
  return <section data-section-id="240339" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-dotted border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          
          <div className="md:col-span-5 space-y-8">
            <Link to="/" className="inline-block">
              <img src="https://eternalblooms.store/wp-content/uploads/2026/05/cropped-Adobe-Express-file.png" alt="Eternal Blooms Ltd" className="h-16 w-auto" />
            </Link>
            
            <div className="space-y-4 text-foreground/80 font-default">
              <div className="flex items-start gap-3">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <p>Auckland, New Zealand (Delivery Region)</p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-5 text-primary shrink-0" />
                <p>027-620-6688</p>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-5 text-primary shrink-0" />
                <p>eternal.blooms.nz2025@gmail.com</p>
              </div>
            </div>

            <Button asChild size="lg" className="w-full sm:w-auto font-default font-medium tracking-wide bg-primary hover:bg-primary/90 text-primary-foreground rounded-full shadow-sm">
              <Link to="tel:0276206688">Contact Studio</Link>
            </Button>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-xl font-default font-semibold text-foreground mb-6 tracking-wide">
              Our Collections
            </h3>
            <MenuProvider menu_id="33">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="md:col-span-3 space-y-8">
            <div>
              <h3 className="text-xl font-default font-semibold text-foreground mb-6 tracking-wide">
                Follow Our Bloom
              </h3>
              <div className="flex gap-4">
                {socialLinks.map((social, i) => {
                const Icon = social.icon;
                const isWeChat = social.label === "WeChat";
                return <Link key={i} data-index={i} to={social.href} newTab={!isWeChat} onClick={e => {
                  if (isWeChat) {
                    e.preventDefault();
                    setIsWeChatModalOpen(true);
                  }
                }} className={`${social.hrefClassName || ""} bg-secondary hover:bg-primary hover:text-primary-foreground text-foreground/60 p-2.5 rounded-full transition-all duration-300 border border-border/50`} aria-label={social.label}>
                  <Icon className="size-5 stroke-[1.5px]" />
                </Link>;
              })}
              </div>
            </div>

            <div>
              <Badge variant="outline" className="border-primary/30 text-primary bg-primary/5 px-4 py-1.5 text-xs tracking-widest uppercase font-default rounded-full">
                Auckland Studio
              </Badge>
            </div>
          </div>
        </div>

        <Separator className="bg-border/30 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-foreground/60 font-default">
          <p>
            &copy; {currentYear} Eternal Blooms Ltd. Handcrafted in Auckland.
          </p>
          <Link to="/HomePage" className="hover:text-primary transition-colors duration-200 flex items-center gap-2">
            Return to Studio
          </Link>
        </div>
      </div>

      {}
      {isWeChatModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-300" onClick={() => setIsWeChatModalOpen(false)}>
          <div className="relative bg-background p-8 rounded-3xl shadow-2xl max-w-sm w-full text-center animate-in zoom-in-95 duration-300 border border-border" onClick={e => e.stopPropagation()}>
            <Button variant="ghost" size="icon" onClick={() => setIsWeChatModalOpen(false)} className="absolute top-4 right-4 text-foreground/40 hover:text-primary hover:bg-primary/10 rounded-full transition-colors" aria-label="Close modal">
              <CloseIcon className="size-6" />
            </Button>
            
            <h4 className="text-xl font-serif font-semibold mb-6 text-foreground">Scan to Connect on WeChat</h4>
            
            <div className="aspect-square bg-muted rounded-2xl overflow-hidden mb-6 border border-border/50">
              <img src="https://eternalblooms.store/wp-content/uploads/2026/05/图片_20260504171949_8_104.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1656137/img/wechat_qr_code.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1656137/img/wechat_qr_code.png-wvc-sizes" alt="WeChat QR Code" className="w-full h-full object-cover" loading="lazy" />
            </div>
            
            <p className="text-sm text-foreground/60 font-default">
              Scan this QR code with your WeChat app to chat with our floral studio.
            </p>
          </div>
        </div>}
    </section>;
}